<template>
  <div>
    <div class="tab-wrapper" :class="{ 'active-tab': isActive, 'no-hover': noHover, untitled }" @click="$emit('click')">
      <n-icon v-if="iconLeft" size="s" :icon="iconLeft" class="icon-left" />
      <n-icon size="s" icon="plus" class="plus-icon" v-if="showAdd" />
      {{ titleOrPlaceholder }}
      <n-icon v-if="iconRight" size="s" :icon="iconRight" class="icon-right" />
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class NTab extends Vue {
  @Prop() title!: String
  @Prop() placeholder?: String
  @Prop() isActive!: boolean
  @Prop({ type: Boolean, default: false }) showAdd?: boolean
  @Prop() iconLeft?: string
  @Prop() iconRight?: string
  @Prop() noHover?: boolean

  get untitled() {
    return !this.title.length
  }

  get titleOrPlaceholder() {
    return this.title.length ? this.title : this.placeholder
  }
}
</script>

<style scoped lang="scss">
@use '@/assets/styles' as *;

.tab-wrapper {
  @include notch-text-label-strong-M;
  width: fit-content;
  color: $notch-color-neutral-sand-600;
  white-space: nowrap;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: $notch-space-2x 0 $notch-space-4x 0;

  &.untitled {
    color: $notch-color-neutral-sand-400;
  }

  &.add-page {
    margin-right: 0;
  }

  &:hover:not(.no-hover) {
    color: $notch-color-neutral-grey-900;
  }

  &:hover:not(.no-hover).untitled {
    color: $notch-color-neutral-sand-600;
  }

  &:focus {
    color: $notch-color-neutral-sand-600;
    border-bottom: 2px solid $notch-color-semantic-accent-500;
  }
}

.plus-icon {
  margin-right: $notch-space-1x;
}

.active-tab {
  color: $notch-color-neutral-grey-900 !important;
  border-bottom: 2px solid $notch-color-neutral-grey-900;

  &.untitled {
    color: $notch-color-neutral-sand-600 !important;
  }
}

.icon-left {
  margin-right: $notch-space-1x;
}

.icon-right {
  margin-left: $notch-space-1x;
}
</style>
